import { InitialValues } from 'forms/types';

import { BenefitAmountFormValues } from '../form/types';
import { GetBenefitAmountQuery } from '../graphql/GetBenefitAmount';

const buildInitialValues = (
  data?: GetBenefitAmountQuery
): InitialValues<BenefitAmountFormValues> => {
  const surveyBenefitAmount = data?.surveyBenefitAmount;

  return {
    benefitAmount: Math.min(
      surveyBenefitAmount?.benefitAmount ?? 0,
      surveyBenefitAmount?.maximumBenefit ?? 0
    ),
    expectIncomeIncrease: surveyBenefitAmount?.expectIncomeIncrease,
  };
};

export default buildInitialValues;
